import React from 'react';
import PropTypes from 'prop-types';
import TimeAgo from 'react-timeago';
import { Table } from 'react-bootstrap';
import Actor from './Actor';
import Event from './Event';
import classes from './Events.scss';

function formatter(value, unit, suffix) {
  // We don't care about the under-minute time resolution
  if (unit === 'second') {
    return 'Less than a minute ago';
  }

  // This is the default formatter take from react-timeago:
  if (value !== 1) {
    unit += 's'; // eslint-disable-line no-param-reassign, no-param-reassign
  }
  return `${value} ${unit} ${suffix}`;
}

export default class EventTable extends React.Component {
  static propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      actor: PropTypes.object.isRequired,
      timestamp: PropTypes.string.isRequired,
    })),
    onModalShow: PropTypes.func.isRequired,
  };

  // Maybe eventually we're going to have different event type components for display details
  // for different events (e.g., a section was update, a widget was updated, etc).
  renderRow = event => (
    <Event
      {...event}
      key={event.id}
      actor={<Actor {...event.actor} />}
      timestamp={<TimeAgo date={event.timestamp} minPeriod={60} formatter={formatter} />}
      onClick={this.props.onModalShow}
      className={classes.row}
    />
  );

  render() {
    const { events } = this.props;

    return (
      <Table striped condensed hover>
        <thead>
          <tr>
            <th>User</th>
            <th>Time</th>
            <th>Event</th>
          </tr>
        </thead>
        <tbody>
          {events.map(this.renderRow)}
        </tbody>
      </Table>
    );
  }
}
